<template>
  <div class="bar-graph">
    <div class="graph-drawing">
      <div class="bars positive" :style="barsStyle">
        <template v-for="barValue of barValuesUI" >
          <bar-graph-value-bar v-if="barValue.valueHeight >= 0" :key="barValue.name" :class="barValue.cssClasses" v-bind="barValue"/>
          <div v-else :key="barValue.name" class="bar-box primary" />
        </template>
      </div>
      <div class="line"></div>
      <div class="bars negative">
        <template v-for="barValue of barValuesUI" >
          <bar-graph-value-bar v-if="barValue.valueHeight < 0" :key="barValue.name" :class="barValue.cssClasses" v-bind="barValue"/>
          <div v-else :key="barValue.name" class="bar-box primary" />
        </template>
      </div>
    </div>
    <div class="month-names" :style="barsStyle">
      <div class="month-name" v-for="barValue of barValuesUI" :key="barValue.name" :class="{ ...barValue.cssClasses, bold: barValue.focused }">
        {{ barValue.name }}
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import BarGraphValueBar from './BarGraphValueBar.vue';

const MAX_CENTERED_BARS = 4;
export default {
  name: 'BarGraph',
  components: {
    BarGraphValueBar,
  },
  props: {
    barValues: {
      type: Array,
      required: true,
    },
    graphHeight: {
      type: Number,
      required: true,
    },
    withSign: {
      type: Boolean,
      default: () => true,
    },
    withCurrency: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    barValuesUI() {
      const heights = this.barValues.map(({ value, secondaryValue }) => secondaryValue ?? value);
      const maxValue = Math.abs(_.max([0, ...heights]));
      const minValue = Math.abs(_.min([0, ...heights]));
      const maxBarHeight = minValue + maxValue;

      return _.map(this.barValues, barValue => {
        const barHeight = (barValue.value / maxBarHeight) * this.graphHeight || 0;
        const barSecondaryHeight = (barValue.secondaryValue / maxBarHeight) * this.graphHeight;
        return {
          ...barValue,
          valueHeight: barHeight,
          secondaryValueHeight: barValue.secondaryValue && barSecondaryHeight,
          withSign: this.withSign,
          withCurrency: this.withCurrency,
        };
      });
    },
    barsStyle() {
      return {
        '--bar-justification': this.barValuesUI.length <= MAX_CENTERED_BARS ? 'center' : undefined,
      };
    },
  },
};

</script>

<style lang="scss">
@import './bar-graph.styles';
</style>
